import { gql } from '@apollo/client';

export const GET_RECOMMENDATIONS = gql`
  query GetRecommendations(
    $skus: [ID]
    $visitorId: ID!
    $eventType: String!
    $placement: String!
    $limit: Int
  ) {
    getRecommendationsV2(
      skus: $skus
      visitorId: $visitorId
      eventType: $eventType
      placement: $placement
      limit: $limit
    ) {
      id
      sku
      variantId
      title
      slug
      available
      weight
      vendor
      metafields {
        key
        value
        namespace
      }
      tags
      type
      price {
        amount
      }
      compareAtPrice {
        amount
      }
      url
      images
      inventory_quantity: inventoryQuantity
    }
  }
`;

export const GET_MERCH_RECOMMENDATIONS = gql`
  query GetMerchRecommendations(
    $widgetId: String!
    $variables: MerchRecommendationsVariables!
    $limit: Int
  ) {
    getRecommendationsV6(
      widgetId: $widgetId
      variables: $variables
      limit: $limit
    ) {
      recommendations
      id
      widget {
        title
        description
      }
      positions {
        sku
        position
      }
    }
  }
`;

export const GET_PRODUCT_BY_HANDLE = gql`
  query GetProductByHandle($handle: String!) {
    getProductByHandle(handle: $handle) {
      metafields {
        key
        value
      }
    }
  }
`;
